import { lazy, Suspense } from "react";

const EmbedPage = lazy(() => import("@/pages/EmbedPage"));
const MainApp = lazy(() => import("@/MainApp"));

function App() {
  const isEmbed = window.location.pathname.replace(/\/+$/, "") === "/embed";

  return (
    <Suspense fallback={null}>
      {isEmbed ? <EmbedPage /> : <MainApp />}
    </Suspense>
  );
}

export default App;
